import {useAuth} from '@apps-common/auth-react';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import {Box, IconButton, Tooltip, Typography, styled} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {getMosaicThumbnailURL} from '../../api.js';
import {formatDate} from '../../util/date.js';
import {Avatar} from '../Avatar.js';

const ItemParent = styled(Box)(({theme, selected}) => ({
  backgroundColor: selected ? theme.palette.primary.light : undefined,
  borderBottom: `solid 1px ${theme.palette.divider}`,
  display: 'flex',
  cursor: 'pointer',
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
}));

ItemParent.propTypes = {
  theme: PropTypes.object,
  selected: PropTypes.bool,
};

const MosaicsReportListItem = ({
  onClick,
  onDetailsClick,
  selected,
  index,
  data,
}) => {
  const {firstAcquired, lastAcquired, source} = data;
  const mosaicId = source.name;
  const handleOpenDetailsDialog = () => onDetailsClick(index);
  const auth = useAuth();
  const thumbnailUrl = getMosaicThumbnailURL(mosaicId, auth.user?.accessToken);

  return (
    <ItemParent onClick={onClick} selected={selected}>
      <Box
        width={64}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Avatar selected={selected}>
          <img width="100%" alt={`${mosaicId} thumbnail`} src={thumbnailUrl} />
        </Avatar>
      </Box>
      <Box
        flex={1}
        overflow="hidden"
        display="flex"
        flexDirection="column"
        justifyContent="center"
      >
        <Typography variant="subtitle1" noWrap>
          {`${formatDate(firstAcquired)} – ${formatDate(lastAcquired)}`}
        </Typography>
      </Box>
      <Box width={72} display="flex" alignItems="center" justifyContent="right">
        <Box mr={1}>
          <Tooltip title="Layer Details">
            <IconButton
              edge="end"
              aria-label="Layer Details"
              onClick={handleOpenDetailsDialog}
              size="large"
            >
              <InfoIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
    </ItemParent>
  );
};

MosaicsReportListItem.propTypes = {
  index: PropTypes.number.isRequired,
  onDetailsClick: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  data: PropTypes.object.isRequired,
};

export default MosaicsReportListItem;
